<template>
    <div>
        <div class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog coupon-modal" role="document">
                <div class="modal-content" style="display: flex; justify-content: center;">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <span v-if="title" class="text-red" style="text-transform: capitalize; font-family: AvertaBlack; font-size: 38px; margin-bottom: 10px;">{{ title }}</span>

                    <p class="text-red">
                        <slot/>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: { required: true },
            title: String,
        },

        mounted () {
            $(this.$refs.modal).on('hidden.bs.modal', () => {
                this.$emit('closed');
            });
        },

        methods: {
            show () {
                $(this.$refs.modal).modal('show');
            },

            hide () {
                $(this.$refs.modal).modal('hide');
            }
        }
    }
</script>
